export const SR_MIN_ITEM_PERCENTAGE = -25;
export const SR_MAX_ITEM_PERCENTAGE = 100;
export const SR_MIN_TOTAL_PERCENTAGE = -100;
export const SR_MAX_TOTAL_PERCENTAGE = 400;
